import type { BigImageTextContent } from '@/core/types';

import { BigImageText } from '@/containers/blocks/image-text';

export default function generate({
  content,
  className,
}: {
  content: BigImageTextContent;
  className?: string;
}) {
  return (
    <BigImageText
      title={content.title}
      description={content.description}
      image={content.image}
      buttons={content.buttons}
      className={className}
    />
  );
}
